import React, {useEffect, useState} from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";

import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import {CircularProgress} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles({
    whatsappBillingNotice: {
        border: '2px solid #ffe082',
        animation: '$pulseWhatsAppBillingBorder 1.4s ease-in-out infinite',
        '@media (prefers-reduced-motion: reduce)': {
            animation: 'none',
            borderColor: '#f59e0b',
        },
    },
    '@keyframes pulseWhatsAppBillingBorder': {
        '0%, 100%': {
            borderColor: '#ffe082',
            boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        },
        '50%': {
            borderColor: '#f97316',
            boxShadow: '0 0 0 3px rgba(249,115,22,0.25), 0 3px 12px rgba(249,115,22,0.28)',
        },
    },
});

const NoticeModal = ({modalOpen, onClose}) => {

    const classes = useStyles();

    const [haveCloudApi, setHaveCloudApi] = useState(false);
    const [loading, setLoading] = useState(true);
    const [consentModalOpen, setConsentModalOpen] = useState(false);
    const [canAcceptConsent, setCanAcceptConsent] = useState(false);
    const [consentAccepted, setConsentAccepted] = useState(false);
    const [acceptingConsent, setAcceptingConsent] = useState(false);
    const [sentinelaToken, setSentinelaToken] = useState("");

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            const fetchOffcial = async () => {
                try {
                    const {data} = await api.get("/whatsapp/api/cloud_api");
                    if (data?.length > 0) {
                        setHaveCloudApi(true);
                    }
                    setLoading(false);
                } catch (err) {
                    toastError(err);
                    setLoading(false);
                }
            };
            fetchOffcial();
        }, 500);
        return () => {
            clearTimeout(delayDebounceFn);
        };
    }, [])

    const handleClose = (_, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
        }
        onClose();
    };

    const handleOpenConsent = () => {
        setCanAcceptConsent(false);
        setConsentAccepted(false);
        setSentinelaToken("");
        setConsentModalOpen(true);
    };

    const handleCloseConsent = () => {
        setConsentModalOpen(false);
        setCanAcceptConsent(false);
        setConsentAccepted(false);
        setAcceptingConsent(false);
        setSentinelaToken("");
    };

    const handleConsentScroll = (event) => {
        const {scrollTop, scrollHeight, clientHeight} = event.currentTarget;

        if (scrollTop + clientHeight >= scrollHeight - 4) {
            setCanAcceptConsent(true);
        }
    };

    const handleAcceptConsent = async () => {
        setAcceptingConsent(true);

        try {
            const {data} = await api.post("/sentinela/custo-atendimento/token");

            if (!data?.token) {
                throw new Error("Token do Sentinela não retornado");
            }

            const expiresIn = Number(data.expires_in) || 300;
            localStorage.setItem("sentinelaCostToken", data.token);
            localStorage.setItem(
                "sentinelaCostTokenExpiresAt",
                String(Date.now() + expiresIn * 1000)
            );

            setSentinelaToken(data.token);
            setConsentAccepted(true);
        } catch (err) {
            toastError(err);
        } finally {
            setAcceptingConsent(false);
        }
    };

    return (
        <>
            <Dialog
                open={modalOpen}
                onClose={handleClose}
            >
                <DialogTitle
                    id="form-dialog-title"
                    style={{position: "relative", paddingRight: 48}}
                >
                    {"Comunicado importante"}
                    <IconButton
                        size="small"
                        onClick={handleClose}
                        aria-label="Fechar"
                        style={{
                            position: "absolute",
                            right: 8,
                            top: "50%",
                            transform: "translateY(-50%)",
                        }}
                    >
                        <CloseIcon fontSize="small"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers style={{fontSize: '13pt', lineHeight: '1.6', color: '#333'}}>
                    { loading && (
                        <div style={{display: "flex", alignItems: "center", gap: 10}}>
                            <CircularProgress size={18}/>
                            <Typography variant="body2">Carregando comunicados...</Typography>
                        </div>
                    )}

                    {!haveCloudApi && !loading && (
                        <div>
                            <span role="img" aria-label="star-and-alert-icon">🚨✨</span> <strong>Comunicado Importante</strong> <span role="img" aria-label="star-and-alert-icon">✨🚨</span>
                            <p>
                                A Meta tem intensificado as políticas de uso e está aplicando <b>restrições</b> e <b>bloqueios</b> em números que utilizam soluções baseadas em APIs não oficiais.
                            </p>

                            <p>
                                <span role="img" aria-label="cadeado">🔐</span>{" "}
                                Para garantir sua segurança e continuidade no atendimento, somos <b>parceiros da Meta</b>.
                                <br/>
                                Caso ocorra qualquer instabilidade ou bloqueio, realizamos todo o processo de <b>migração para a API Oficial do WhatsApp</b>, assegurando estabilidade e conformidade com as regras atuais.
                            </p>

                            <p>
                                <span role="img" aria-label="raio">⚡</span>{" "}
                                Pensando em tornar esse processo <b>mais rápido e sem imprevistos</b>, recomendamos que sua empresa já realize a <b>criação do portfólio</b> e a <b>verificação junto à Meta</b>.
                            </p>

                            <p>
                                <strong>
                                    <span role="img" aria-label="link">🔗</span>{' '}
                                    <a
                                        href="https://docs.google.com/presentation/d/e/2PACX-1vSe_xDpbXrtxosxRv-rB67mBtrWPZ_Dpo89uYz2cayS3VVw0MCAdcFpD6nHs4pQy2DosxhP309V6AlW/pub?start=true&loop=false&delayms=5000"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{color: '#1976d2', textDecoration: 'none'}}
                                    >
                                        Clique aqui
                                    </a>
                                </strong> e descubra como as novas políticas da Meta afetarão seu uso.
                            </p>

                            <p style={{marginTop: 12}}>
                                <strong>Assista o vídeo abaixo: <span role="img" aria-label="FingerDown">👇🏻</span><span role="img" aria-label="FingerDown">👇🏻</span></strong>
                            </p>

                            <div
                                style={{
                                    marginTop: '1rem',
                                    padding: '12px',
                                    background: '#f5f7fa',
                                    borderRadius: 10,
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                }}
                            >
                                <div style={{maxWidth: 270, margin: '0 auto'}}>
                                    <video
                                        controls
                                        preload="metadata"
                                        playsInline
                                        style={{
                                            width: '100%',
                                            borderRadius: 8,
                                            backgroundColor: '#000',
                                        }}
                                    >
                                        <source
                                            src="https://app.goneweb.com.br/patch_notes/public/cloudapi.mp4"
                                            type="video/mp4"
                                        />
                                        Seu navegador não suporta vídeo.
                                    </video>
                                </div>
                            </div>
                        </div>
                    )}

                    {haveCloudApi && !loading && (
                        <>
                            <div
                                className={classes.whatsappBillingNotice}
                                style={{
                                    padding: '18px',
                                    background: '#fff8e1',
                                    borderRadius: 10,
                                }}
                            >
                            <h3 style={{margin: '0 0 1rem', color: '#b45309'}}>
                                <span role="img" aria-label="atenção">⚠️</span>{' '}
                                Nova cobrança do WhatsApp já em vigor
                            </h3>

                            <p>
                                Desde <strong>1º de outubro de 2026</strong>, a Meta passou a cobrar
                                também por <strong>cada mensagem de atendimento enviada pela empresa</strong>{' '}
                                dentro da janela de 24 horas, incluindo respostas comuns sem template.
                            </p>

                            <p>
                                Os templates continuarão sendo cobrados conforme sua categoria, e os valores
                                poderão variar de acordo com o país do destinatário.
                            </p>

                            <p
                                style={{
                                    padding: '12px',
                                    background: '#fff',
                                    borderLeft: '4px solid #f59e0b',
                                    borderRadius: 4,
                                    fontSize: '12pt',
                                }}
                            >
                                <span role="img" aria-label="informação">ℹ️</span>{' '}
                                <strong>Esta alteração é definida pela Meta, não por nossa plataforma,</strong>{' '}
                                e afeta todas as empresas que utilizam a API Oficial do WhatsApp.
                            </p>

                            <div
                                style={{
                                    display: 'flex',
                                    gap: 8,
                                    marginTop: '1rem',
                                }}
                            >
                                <a
                                    href="https://developers.facebook.com/documentation/business-messaging/whatsapp/pricing/non-template-messages"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flex: '1 1 0',
                                        padding: '7px 9px',
                                        background: '#1976d2',
                                        color: '#fff',
                                        fontSize: '10.5pt',
                                        fontWeight: 'bold',
                                        lineHeight: 1.3,
                                        textAlign: 'center',
                                        textDecoration: 'none',
                                        borderRadius: 6,
                                    }}
                                >
                                    Comunicado oficial da Meta ↗
                                </a>
                                <a
                                    href="https://developers.facebook.com/documentation/business-messaging/whatsapp/pricing"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flex: '1 1 0',
                                        padding: '7px 9px',
                                        background: '#fff',
                                        color: '#1976d2',
                                        fontSize: '10.5pt',
                                        fontWeight: 'bold',
                                        lineHeight: 1.3,
                                        textAlign: 'center',
                                        textDecoration: 'none',
                                        border: '1px solid #1976d2',
                                        borderRadius: 6,
                                    }}
                                >
                                    Consulte as regras e tarifas ↗
                                </a>
                            </div>
                            </div>

                            <div
                                style={{
                                    marginTop: '0.75rem',
                                    padding: '12px 14px',
                                    background: '#f3f8f3',
                                    border: '1px solid #c8dfca',
                                    borderRadius: 8,
                                }}
                            >
                                <h3
                                    style={{
                                        margin: '0 0 0.35rem',
                                        color: '#3f6f42',
                                        fontSize: '12pt',
                                    }}
                                >
                                    Otimize seus custos e seu atendimento
                                </h3>

                                <p
                                    style={{
                                        margin: '0 0 0.65rem',
                                        fontSize: '10.5pt',
                                        lineHeight: 1.45,
                                    }}
                                >
                                    Quer saber como podemos ajudar sua empresa a reduzir os custos com mensagens
                                    e tornar o atendimento ainda mais eficiente?
                                </p>

                                <button
                                    type="button"
                                    onClick={handleOpenConsent}
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: '6px 12px',
                                        background: '#3f6f42',
                                        color: '#fff',
                                        fontSize: '9.5pt',
                                        fontWeight: 'bold',
                                        fontFamily: 'inherit',
                                        border: 0,
                                        borderRadius: 5,
                                        cursor: 'pointer',
                                    }}
                                >
                                    Saiba mais
                                </button>
                            </div>
                        </>
                    )}
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={handleClose}
                        color={"primary"}
                        disabled={loading}
                        variant={"contained"}
                    >
                        {"Estou ciente"}
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={consentModalOpen}
                onClose={handleCloseConsent}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle style={{position: 'relative', paddingRight: 48}}>
                    {consentAccepted ? 'Análise dos atendimentos' : 'Termo de Processamento de Dados'}
                    <IconButton
                        size="small"
                        onClick={handleCloseConsent}
                        aria-label="Fechar"
                        style={{
                            position: 'absolute',
                            right: 8,
                            top: '50%',
                            transform: 'translateY(-50%)',
                        }}
                    >
                        <CloseIcon fontSize="small"/>
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    {!consentAccepted ? (
                        <>
                            <Typography variant="body2" style={{marginBottom: 12}}>
                                Leia o termo até o final para habilitar a opção de aceite.
                            </Typography>

                            <div
                                onScroll={handleConsentScroll}
                                tabIndex={0}
                                role="region"
                                aria-label="Termo de Processamento de Dados do Sentinela Contábil"
                                style={{
                                    height: 280,
                                    overflowY: 'auto',
                                    padding: '14px 18px',
                                    background: '#f7f7f7',
                                    border: '1px solid #ddd',
                                    borderRadius: 6,
                                    fontSize: '10.5pt',
                                    lineHeight: 1.6,
                                    color: '#333',
                                }}
                            >
                                <h3 style={{marginTop: 0}}>
                                    Termo de Processamento de Dados — Sentinela Contábil
                                </h3>

                                <p>
                                    <strong>1. Partes.</strong> Este Termo é celebrado entre o Sentinela Contábil
                                    (“Operador”), plataforma de análise de risco para escritórios de contabilidade, e o
                                    escritório de contabilidade titular desta conta (“Controlador”).
                                </p>

                                <p>
                                    <strong>2. O que o Sentinela faz.</strong> O Sentinela acessa as conversas de
                                    atendimento registradas no WhatsContabil e realiza análise automatizada para
                                    identificar riscos para a carteira do escritório, como insatisfação de clientes,
                                    temas fiscais pendentes, conduta inadequada de colaboradores e ausência de respostas.
                                </p>

                                <div>
                                    <strong>3. Dados acessados.</strong>
                                    <ul style={{marginTop: 4}}>
                                        <li>Identificador e conteúdo das conversas de atendimento;</li>
                                        <li>Nome do cliente e do colaborador responsável pelo atendimento;</li>
                                        <li>Fila ou setor de atendimento;</li>
                                        <li>Data e horário das mensagens.</li>
                                    </ul>
                                    <p>
                                        Nenhum dado bancário, CPF, CNPJ ou senha de acesso a sistemas é coletado pelo
                                        Sentinela.
                                    </p>
                                </div>

                                <p>
                                    <strong>4. Finalidade do processamento.</strong> Os dados são utilizados exclusivamente
                                    para gerar alertas de risco, relatórios gerenciais e sugestões de ação para o próprio
                                    escritório titular da conta. Nenhum dado é utilizado para treinar modelos de
                                    inteligência artificial ou compartilhado com outros escritórios.
                                </p>

                                <p
                                    style={{
                                        padding: 10,
                                        background: '#fff8e1',
                                        borderLeft: '3px solid #f59e0b',
                                        borderRadius: 4,
                                    }}
                                >
                                    <strong>5. Subprocessador de IA.</strong> A análise automática das conversas é realizada
                                    pela Anthropic, nos Estados Unidos, por meio do modelo Claude. O conteúdo das conversas
                                    é transmitido aos servidores da Anthropic somente para processamento, conforme os
                                    termos de uso e a política de privacidade da empresa, sem armazenamento além do
                                    necessário para processar cada requisição.
                                </p>

                                <p>
                                    <strong>6. Retenção dos dados.</strong> Os alertas gerados pelo Sentinela são armazenados
                                    enquanto a conta do escritório estiver ativa. Após o encerramento do contrato, os dados
                                    são eliminados em até 90 dias. O conteúdo original das conversas não é armazenado pelo
                                    Sentinela — apenas os alertas e resumos gerados a partir delas.
                                </p>

                                <p>
                                    <strong>7. Segurança.</strong> Os dados de cada escritório são isolados por identificador
                                    único de tenant. Nenhum escritório tem acesso aos dados de outro. O acesso à plataforma
                                    é protegido por autenticação com senha e tokens de sessão com expiração automática.
                                </p>

                                <div
                                    style={{
                                        padding: 10,
                                        background: '#fff8e1',
                                        borderLeft: '3px solid #f59e0b',
                                        borderRadius: 4,
                                    }}
                                >
                                    <strong>8. Responsabilidade do Controlador.</strong> Ao aceitar este termo, o escritório
                                    declara que:
                                    <ul style={{marginBottom: 0}}>
                                        <li>
                                            possui base legal adequada sob a LGPD para processar os dados pessoais dos
                                            clientes finais cujas conversas serão analisadas;
                                        </li>
                                        <li>
                                            está ciente do processamento das conversas pela IA da Anthropic, em servidores
                                            nos Estados Unidos, para fins de análise de risco;
                                        </li>
                                        <li>
                                            é responsável por informar seus clientes finais sobre o uso de ferramentas de
                                            análise automatizada, quando exigido.
                                        </li>
                                    </ul>
                                </div>

                                <p>
                                    <strong>9. Direitos dos titulares.</strong> Nos termos do artigo 18 da LGPD, são
                                    assegurados aos titulares direitos como acesso, correção e eliminação dos dados
                                    armazenados. As solicitações podem ser realizadas pelo canal de suporte informado na
                                    tela de Configurações da plataforma.
                                </p>

                                <p style={{marginBottom: 0}}>
                                    <strong>10. Vigência.</strong> Este Termo entra em vigor na data do aceite e permanece
                                    válido durante o uso da plataforma. Alterações relevantes serão comunicadas com
                                    antecedência e exigirão novo aceite. <strong>Versão 1.0 — vigência a partir de agosto
                                    de 2026.</strong>
                                </p>
                            </div>
                        </>
                    ) : (
                        <div style={{textAlign: 'center'}}>
                            <Typography variant="h6" style={{marginBottom: 16}}>
                                Veja uma análise breve sobre seus últimos atendimentos
                            </Typography>
                            <iframe
                                src={`https://sentinela.whatscontabil.com.br/embed/custo-atendimento?token=${encodeURIComponent(sentinelaToken)}`}
                                title="Análise breve dos últimos atendimentos"
                                style={{
                                    display: 'block',
                                    width: '100%',
                                    height: '65vh',
                                    minHeight: 520,
                                    border: '1px solid #d7dce2',
                                    borderRadius: 8,
                                }}
                            />
                        </div>
                    )}
                </DialogContent>

                <DialogActions>
                    {!consentAccepted ? (
                        <>
                            <Button onClick={handleCloseConsent} color="default">
                                Cancelar
                            </Button>
                            <Button
                                onClick={handleAcceptConsent}
                                color="primary"
                                variant="contained"
                                disabled={!canAcceptConsent || acceptingConsent}
                                startIcon={acceptingConsent ? <CircularProgress size={16}/> : null}
                            >
                                {acceptingConsent ? 'Carregando análise...' : 'Li e aceito'}
                            </Button>
                        </>
                    ) : (
                        <Button onClick={handleCloseConsent} color="primary" variant="contained">
                            Fechar
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </>
    );
};

export default NoticeModal;
